<template>
  <div class="exam-content">
    <h3>2020迎“七•一”，党建知识竞赛</h3>
    <p>第九城市党总支</p>
    <!-- 计时器 -->
    <div class="timer">
      <div ref="startTimer"></div>
    </div>
    <!-- 题目开始 -->
    <div class="answer-part">
      <div v-for="(item,index) in questionList"
           :key="index">
        <div v-show="c_index === index">
          <div class="content-title">{{item.name}} {{item.question}}</div>
          <div class="userName">
            <van-field v-model="value"
                       label="请输入答案"
                       :placeholder="`${item.answer.length}个字`" />
          </div>
        </div>
      </div>
    </div>
    <van-button type="info"
                @click="next"
                class="next">下一题</van-button>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data () {
    return {
      user_name: '',
      c_index: 0,
      // 计时部分
      timer: "",
      content: "",
      hour: 0,
      minutes: 0,
      seconds: 0,
      // 题目数组
      questionList: [],
      questionList_old: [
        {
          name: 'Q1',
          question: '党的最高理想和最终目标是实现_____。',
          answer: '共产主义'
        },
        {
          name: 'Q2',
          question: '中国梦：实现中华民族_____，是近代以来中国人民最伟大的梦想。',
          answer: '伟大复兴'
        }, {
          name: 'Q3',
          question: '中国共产党人的初心和使命是：为中国人民谋______，为中华民族谋复兴。',
          answer: '幸福'
        }
        , {
          name: 'Q4',
          question: '党的行动指南是：马克思列宁主义、毛泽东思想、邓小平理论、“三个代表”重要思想、科学发展观和____新时代中国特色社会主义思想。',
          answer: '习近平'
        }, {
          name: 'Q5',
          question: '党的思想路线是：一切从实际出发，理论联系实际，_______，在实践中检验真理和发展真理。',
          answer: '实事求是'
        }, {
          name: 'Q6',
          question: '党的三大历史任务是：推进现代化建设、完成______、维护世界和平与促进共同发展。',
          answer: '祖国统一'
        }, {
          name: 'Q7',
          question: '党的三大作风是：理论联系实际、密切联系群众、_____与自我批评。',
          answer: '批评'
        }, {
          name: 'Q8',
          question: '社会主义核心价值观是：富强、民主、文明、和谐，自由、平等、公正、法治，爱国、____、诚信、友善。',
          answer: '敬业'
        }, {
          name: 'Q9',
          question: '中国共产党是中国工人阶级的_____。',
          answer: '先锋队'
        }, {
          name: 'Q10',
          question: '党在社会主义初级阶段的基本路线，领导和团结全国各族人民，以经济建设为中心，坚持四项基本原则，坚持改革开放，自力更生，______，为把我国建设成为富强民主文明和谐美丽的社会主义现代化强国而奋斗。',
          answer: '艰苦创业'
        }, {
          name: 'Q11',
          question: '党的十九届中央委员会第一次全体会议选举习近平、李克强、栗战书、汪洋、王沪宁、赵乐际、_______为中央政治局常委。',
          answer: '韩正'
        }, {
          name: 'Q12',
          question: '“两个一百年”奋斗目标：到____一百年时，使国民经济更加发展，各项制度更加完善；到世纪中叶建国一百年时，基本实现现代化，建成富强民主文明的社会主义国家。',
          answer: '建党'
        }, {
          name: 'Q13',
          question: '党的十九大的主题是：______，牢记使命，高举中国特色社会主义伟大旗帜，决胜全面建成小康社会，夺取新时代中国特色社会主义伟大胜利，为实现中华民族伟大复兴的中国梦不懈奋斗。',
          answer: '不忘初心'
        }, {
          name: 'Q14',
          question: '十九大报告指出，经过长期努力，中国特色社会主义进入了_____ ，这是我国发展新的历史方位。',
          answer: '新时代'
        }, {
          name: 'Q15',
          question: '中国特色社会主义进入新时代，我国社会主要矛盾已经转化为：人民日益增长的_______需要和不平衡不充分的发展之间的矛盾。',
          answer: '美好生活'
        }, {
          name: 'Q16',
          question: '十九大报告指出，我国社会主要矛盾的变化，没有改变我们对我国社会主义所处历史阶段的判断，我国仍处于并将长期处于社会主义初级阶段的基本国情没有变，我国是____发展中国家的国际地位没有变。',
          answer: '世界最大'
        }, {
          name: 'Q17',
          question: '中国特色社会主义最本质的特征是_______领导 。',
          answer: '中国共产党'
        }, {
          name: 'Q18',
          question: '新基建本质上是信息数字化的基础设施，目前新基建主要包括七大领域：5G基建、特高压、城际高速铁路和城市轨道交通、新能源汽车充电桩、大数据中心、______、工业互联网。',
          answer: '人工智能'
        }, {
          name: 'Q19',
          question: '新时代坚持和发展中国特色社会主义的十四条基本方略，第一条是：坚持党对_____工作的领导',
          answer: '一切'
        }, {
          name: 'Q20',
          question: '社会主义核心___ 是当代中国精神的集中体现，凝结着全体人民共同的价值追求。',
          answer: '价值观'
        }, {
          name: 'Q21',
          question: '全国两会是指：全国人民代表大会，中国人民_____会议。',
          answer: '政治协商'
        }, {
          name: 'Q22',
          question: '树立___是核心战斗力的思想，推进重大技术创新、自主创新，加强军事人才培养体系建设，建设创新型人民军队。',
          answer: '科技'
        }, {
          name: 'Q23',
          question: '国共产党始终把为_____作出新的更大的贡献作为自己的使命。',
          answer: '人类'
        }, {
          name: 'Q24',
          question: '一个政党，一个政权，其前途命运取决于人心向背。人民群众反对什么、痛恨什么，我们就要坚决防范和______什么。',
          answer: '纠正'
        }, {
          name: 'Q25',
          question: '发展是解决我国一切问题的基础和关键，发展必须是科学发展，必须坚定不移贯彻____ 、协调、绿色、开放、共享的发展理念。',
          answer: '创新'
        }, {
          name: 'Q26',
          question: '旗帜鲜明讲____ 是我们党作为马克思主义政党的根本要求。',
          answer: '政治'
        }, {
          name: 'Q27',
          question: '新党章明确，中央军事委员会实行____ 负责制。',
          answer: '主席'
        }, {
          name: 'Q28',
          question: '从2020年到本世纪中叶,第一个阶段，从二〇二〇年到二〇三五年，在全面建成_____的基础上，再奋斗十五年，基本实现社会主义现代化。',
          answer: '小康社会'
        }, {
          name: 'Q29',
          question: '四个意识是：政治意识、大局意识、核心意识、____。',
          answer: '看齐意识'
        }, {
          name: 'Q30',
          question: '三会一课是：支部党员大会、支部委员会、党小组会、_____。',
          answer: '党课'
        }, {
          name: 'Q31',
          question: '三严三实是：严以修身、严以用权、严以律己，谋事要实、创业要实、_____要实。',
          answer: '做人'
        }, {
          name: 'Q32',
          question: '党内政治生活“四性”是指：政治性、时代性、____性、战斗性。',
          answer: '原则'
        }, {
          name: 'Q33',
          question: '“控制总量、优化结构、提高质量、发挥作用。”简称______“十六字”方针',
          answer: '发展党员'
        }
      ],
      value: ''
    }
  },
  created () {
    this.user_name = this.$route.params.name;
    // 设置时间速度
    this.timer = setInterval(this.startTimer, 1000);
    //生成随机题目
    const len = this.questionList_old.length;
    for (let i = 0; i < len; i++) {
      const idx = this.GetRandomNum(0, len - i - 1);
      this.questionList.push(this.questionList_old[idx]);
      this.questionList_old.splice(idx, 1);
    }
  },
  destroyed () {
    clearInterval(this.timer);
  },
  methods: {
    async postData (name, durations) {
      try {
        const re = await axios({
          url: "/php/index.php",
          method: 'get',
          params: { name, durations }
        });
        if (re.data.code == 0) {
          return re.data.data;
        }
        else {
          console.error(re.data.message);
        }
      }
      catch (error) {
        console.error(error);
      }
      return false;
    },

    async next () {
      if (this.c_index < this.questionList.length - 1) {
        this.c_index++;
        console.log(this.minutes + '分' + this.seconds + '秒')
      } else {
        const re = await this.postData(this.user_name, this.minutes * 60 + this.seconds);
        debugger
        if (re) {
          console.log('ok:', re);
        }
        this.$router.push({ name: 'end', params: { re } });
      }
      // 当前的问题数据
      let c_questionList = this.questionList[this.c_index - 1]
      // 如果答案不对，则将此条数据添加到数组最后
      if (this.value !== c_questionList.answer) {
        this.questionList.push(c_questionList)
        this.value = '';
      } else {
        this.value = '';
      }
    },
    // 随机抽取数组
    GetRandomNum (Min, Max) {
      var Range = Max - Min;
      var Rand = Math.random();
      return (Min + Math.round(Rand * Range));
    },
    // 计时器函数
    startTimer () {
      this.seconds += 1;
      if (this.seconds >= 60) {
        this.seconds = 0;
        this.minutes = this.minutes + 1;
      }
      if (this.minutes >= 60) {
        this.minutes = 0;
        this.hour = this.hour + 1;
      }
      this.$refs.startTimer.innerHTML = (this.minutes < 10 ? '0' + this.minutes : this.minutes) + ':' + (this.seconds < 10 ? '0' + this.seconds : this.seconds);
    }
  }
}

</script>
<style scoped>
.exam-content {
  width: 90%;
  margin: 0 auto;
}
.answer-part {
  position: relative;
}
@media screen and (min-width: 700px) {
  .exam-content {
    width: 50%;
  }
}
.userName {
  position: absolute;
  top: 80px;
  left: 15%;
}
.next {
  position: absolute;
  top: 330px;
  left: 50%;
}
</style>


// WEBPACK FOOTER //
// src/components/exam.vue